import { AlertModal } from '@doxyme/ui/components/patterns';
import { NavigationConfirmationAlert } from '../../navigationConfirmationAlert';
import { useExtensionsNavigationInterception } from '../../../hooks/useExtensions/useExtensionsNavigationInterception';

export function ExtensionsNavigationConfirmationAlert() {
  const {
    navigationConfirmationReasons,
    manualTriggeredReason,
    clearNavigationConfirmationReasons,
    resolveManualTrigger,
  } = useExtensionsNavigationInterception();
  const navigationConfirmationReason = navigationConfirmationReasons[0];
  return (
    <>
      <NavigationConfirmationAlert
        alertTextProps={{
          title: navigationConfirmationReason?.title || '',
          description: navigationConfirmationReason?.description || '',
          primaryButtonText: navigationConfirmationReason?.stayButtonText || '',
          secondaryButtonText:
            navigationConfirmationReason?.leaveButtonText || '',
        }}
        shouldBlockNavigation={Boolean(navigationConfirmationReason)}
        onLeave={() => {
          clearNavigationConfirmationReasons();
        }}
        domain='extensions'
        allowClientSideNavigation={
          navigationConfirmationReason?.allowClientSideNavigation
        }
      />
      {manualTriggeredReason && (
        <AlertModal
          isOpen
          statusIcon='warning'
          title={manualTriggeredReason.title}
          description={manualTriggeredReason.description}
          onClose={() => resolveManualTrigger('stay')}
          primaryButton={{
            text: manualTriggeredReason.stayButtonText,
            onClick: () => resolveManualTrigger('stay'),
          }}
          secondaryButton={{
            text: manualTriggeredReason.leaveButtonText,
            onClick: () => resolveManualTrigger('leave'),
          }}
        />
      )}
    </>
  );
}
